import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {FavoritesComponent} from '../favorites.component';

@Component({
  selector: 'app-favorites-modal',
  templateUrl: './favorites-modal.component.html',
  styleUrls: ['./favorites-modal.component.css']
})
export class FavoritesModalComponent implements OnInit {
  editFavorites: boolean;
  staffAssignedPortals: any[];
  @ViewChild('appFavorites', { static: true }) appFavorites: FavoritesComponent;
  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {
    this.editFavorites = this.data.editFavorites;
    this.staffAssignedPortals = this.data.staffAssignedPortals;
  }

  ngOnInit() {
  }

  expandAllClick(expandSection:boolean) {
    this.appFavorites.expandAllClick(expandSection);
  }

  closeClick() {
    this.appFavorites.closeClick();
  }

  saveClick() {
    this.appFavorites.saveClick();
  }

}
